export default {
    'keep-kr': '@:terms.keep-kr',
    'subsidy-title': '@:terms.hidden-subsidy',
    'heumlabs': '@:terms.heum @:terms.labs가',
    'can-take-subsidy': '받을 수 있는 @:terms.subsidy',
    'postposition-eun': '은',
    'postposition-eul': '을',
    'postposition-leega': '이(가)',
    'how-much': '얼마일까요?',
    'inquiring': '조회중입니다.',
    'employee': '@:terms.employee',
    'company-location': '@:terms.company-location',
    'company-kind': '@:terms.company-kind',
    'persons': '@:terms.persons',
    'currency': '@:terms.currency',
    'prediction-maximum-subsidy': '@:terms.prediction @:terms.subsidy(@:terms.maximum)',
    'heum-recommend-title': '@:terms.heum@:terms.labs @:terms.recommend @:terms.subsidy',
    'recommend-title': '@:terms.recommend @:terms.subsidy',
    'outline': '@:terms.outline',
    'particular-content': '@:terms.particular@:terms.content',
    'name': '@:terms.name',
    'birthday': '@:terms.birthday',
    'youth-add-employ-subsidy': '@:terms.youth@:terms.add@:terms.employ@:terms.subsidy',
    'proposal-able-start-date': '@:terms.proposal @:terms.able @:terms.start@:terms.month',
    'months-after': '@:terms.months @:terms.after',
    'none-cert': ['공동인증서가', '등록되지 않았습니다.'],
    'footer': {
      'register-cert': '@:terms.certificate 등록하기',
      'free-subsidy-consultation': '@:terms.subsidy @:terms.free @:terms.consultation',
      'closed': '"2021년 청년 추가고용 장려금 지원사업" 신규 지원신청이 마감되었습니다.'
    },
  }
  